import type { GetExecutionResponse } from '@blockworks/platform/api/research/studio/execution';

const validateExecution = (execution: GetExecutionResponse['data']) => {
    if (execution?.error) {
        throw new Error(`${execution.error}`);
    }

    if (execution?.rows?.length === 0) {
        throw new Error(`Returned with no data `);
    }

    return execution;
};

export { validateExecution };
